import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(_, { inboxId, agentList, agentLimits }) {
    return InboxMembersAPI.update({ inboxId, agentList, agentLimits });
  },
};

export default {
  namespaced: true,
  actions,
};
